import React from "react";
import { SwitchInput, SwitchLabel, SwitchText, SwitchTrack } from "./Switch.styles";
import { SwitchProps } from "./Switch.types";

const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  label,
  ariaLabel,
  disabled = false,
}) => (
  <SwitchLabel>
    <SwitchInput
      type="checkbox"
      checked={checked}
      disabled={disabled}
      aria-label={ariaLabel || label}
      onChange={(event) => onChange(event.target.checked)}
    />
    <SwitchTrack $checked={checked} $disabled={disabled} aria-hidden="true" />
    {label && <SwitchText>{label}</SwitchText>}
  </SwitchLabel>
);

export default Switch;
